module.exports = __webpack_public_path__ + "4c6c722a9d3af2e7117a0a50cf6d4410.svg";